import { FirestoreService } from '../firebase/firestore';
import { mockTables } from '../data/mockData';

/**
 * Utility function to populate tables in Firestore
 * Run this once to push mock tables to Firebase
 */
export const populateTables = async () => {
  console.log('🚀 Starting to populate tables in Firestore...');
  console.log('📊 Tables to add:', mockTables);

  try {
    // Check if tables already exist
    const existingTables = await FirestoreService.getTables();
    console.log('📋 Existing tables in Firestore:', existingTables.length);

    if (existingTables.length > 0) {
      console.log('⚠️ Tables already exist in Firestore. Skipping...');
      return {
        success: true,
        message: 'Tables already exist',
        count: existingTables.length
      };
    }

    // Add each table to Firestore
    const results = [];
    for (const table of mockTables) {
      console.log('➕ Adding table:', table.tableNumber);
      const tableId = await FirestoreService.addTable({
        tableNumber: table.tableNumber,
        status: table.status,
        capacity: table.capacity,
        location: table.location
      });

      if (tableId) {
        console.log('✅ Table added successfully with ID:', tableId);
        results.push({ tableNumber: table.tableNumber, id: tableId });
      } else {
        console.error('❌ Failed to add table:', table.tableNumber);
      }
    }

    console.log('🎉 All tables populated successfully!');
    console.log('📊 Results:', results);

    // Clear localStorage to force reload from Firebase
    localStorage.removeItem('bookfood_tables');
    console.log('🧹 Cleared localStorage tables cache');

    return {
      success: true,
      message: 'Tables populated successfully',
      count: results.length,
      tables: results
    };
  } catch (error) {
    console.error('❌ Error populating tables:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error',
      count: 0
    };
  }
};

/**
 * Force repopulate - deletes existing tables and adds fresh ones
 */
export const forceRepopulateTables = async () => {
  console.log('🔄 Force repopulating tables...');

  try {
    // Get existing tables
    const existingTables = await FirestoreService.getTables();
    console.log('📋 Found', existingTables.length, 'existing tables');

    // Delete all existing tables
    for (const table of existingTables) {
      if (table.id) {
        console.log('🗑️ Deleting table:', table.tableNumber);
        await FirestoreService.deleteTable(table.id);
      }
    }

    console.log('✅ All existing tables deleted');

    // Add fresh tables
    const results = [];
    for (const table of mockTables) {
      console.log('➕ Adding table:', table.tableNumber);
      const tableId = await FirestoreService.addTable({
        tableNumber: table.tableNumber,
        status: table.status,
        capacity: table.capacity,
        location: table.location
      });

      if (tableId) {
        console.log('✅ Table added successfully with ID:', tableId);
        results.push({ tableNumber: table.tableNumber, id: tableId });
      }
    }

    console.log('🎉 Tables force repopulated successfully!');
    
    // Clear localStorage to force reload from Firebase
    localStorage.removeItem('bookfood_tables');
    console.log('🧹 Cleared localStorage tables cache');

    return {
      success: true,
      message: 'Tables force repopulated successfully',
      count: results.length,
      tables: results
    };
  } catch (error) {
    console.error('❌ Error force repopulating tables:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error',
      count: 0
    };
  }
};
